import React from 'react';

import { PageTitle } from '../../../components';
import { CaseSection } from '../..';



const CasePage = () => {
 
  return ( 
    <>

      {/* Page Title */}
      <PageTitle title={'Case Studies'} page={'Case Studies'} />

      {/* Case Studies Section */}
      <CaseSection />

    </>
  );
  
}

export default CasePage;